export default "__VITE_ASSET__BTwEL5ZL__"